import { DECISION_NAMES } from '@operations/domain/operation/detail';
import type {
  DecisionArea,
  DecisionStatus,
} from '@operations/domain/operation/types/operationDetail';

const STATUS_CLASSES: Record<DecisionStatus, string> = {
  approved: 'bg-success text-success-foreground',
  rejected: 'bg-destructive text-destructive-foreground',
  pending: 'bg-secondary text-secondary-foreground',
};

const BADGE_BASE_CLASS =
  'inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold ring-1 ring-inset ring-foreground/25';

const DECISION_AREA_ORDER = Object.fromEntries(
  Object.keys(DECISION_NAMES).map((key, i) => [key, i]),
) as Record<DecisionArea, number>;

export { BADGE_BASE_CLASS, DECISION_AREA_ORDER, STATUS_CLASSES };
